/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Jump_Confirmation_DescriptionInputs */

const en_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falling behind? Continue from ${i?.number} minutes and keep focusing!`)
};

const ar_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل تأخرت؟ تابع من الدقيقة ${i?.number} وواصل التركيز!`)
};

const de_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Im Rückstand? Mach bei ${i?.number} Min. weiter und bleib fokussiert!`)
};

const es_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Te estás quedando atrás? Continúa desde ${i?.number} min y sigue concentrándote.`)
};

const fr_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez pris du retard ? Reprenez à ${i?.number} min et continuez à vous concentrer !`)
};

const it_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei indietro? Riparti da ${i?.number} min e continua a concentrarti!`)
};

const ja_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`進捗が遅れていますか？${i?.number}分から再開して、集中を続けましょう！`)
};

const ko_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`진행이 늦어졌나요? ${i?.number}분부터 이어서 집중해 보세요!`)
};

const pt_br_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Está ficando para trás? Continue a partir de ${i?.number} min e mantenha o foco!`)
};

const ru_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отстаёте? Продолжите с ${i?.number} мин и сохраняйте концентрацию!`)
};

const th_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ตามหลังอยู่ใช่ไหม? ไปต่อจาก ${i?.number} นาที แล้วโฟกัสต่อเลย!`)
};

const tr_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geride mi kaldın? ${i?.number} dakikadan devam et ve odaklanmayı sürdür!`)
};

const zh_cn_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`进度落后了吗？直接跳至 ${i?.number} 分钟，继续累积专注时间！`)
};

const zh_tw_jump_confirmation_description = /** @type {(inputs: Jump_Confirmation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`進度落後了嗎？直接跳至 ${i?.number} 分鐘，繼續累積專注時間！`)
};

/**
* | output |
* | --- |
* | "Falling behind? Continue from {number} minutes and keep focusing!" |
*
* @param {Jump_Confirmation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const jump_confirmation_description = /** @type {((inputs: Jump_Confirmation_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jump_Confirmation_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jump_confirmation_description(inputs)
	if (locale === "ar") return ar_jump_confirmation_description(inputs)
	if (locale === "de") return de_jump_confirmation_description(inputs)
	if (locale === "es") return es_jump_confirmation_description(inputs)
	if (locale === "fr") return fr_jump_confirmation_description(inputs)
	if (locale === "it") return it_jump_confirmation_description(inputs)
	if (locale === "ja") return ja_jump_confirmation_description(inputs)
	if (locale === "ko") return ko_jump_confirmation_description(inputs)
	if (locale === "pt_br") return pt_br_jump_confirmation_description(inputs)
	if (locale === "ru") return ru_jump_confirmation_description(inputs)
	if (locale === "th") return th_jump_confirmation_description(inputs)
	if (locale === "tr") return tr_jump_confirmation_description(inputs)
	if (locale === "zh_cn") return zh_cn_jump_confirmation_description(inputs)
	return zh_tw_jump_confirmation_description(inputs)
});